import SpecialistServiceDetail from "@/components/SpecialistServiceDetail";

const DIABETES = "https://images.pexels.com/photos/16984203/pexels-photo-16984203.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1200";

export default function DiabetesReversal() {
  return (
    <SpecialistServiceDetail
      testid="diabetes-reversal-page"
      eyebrow="DIABETES REVERSAL"
      title="Diabetes Reversal"
      subtitle="Better choices. Healthier tomorrow."
      image={DIABETES}
      accent="#0284C7"
      box="#E0F2FE"
      aiPrompt="Help me build a diabetes reversal plan."
      offerings={[
        "Endocrinologist & diabetologist consultations",
        "Personalised nutrition and lifestyle plans",
        "Continuous glucose monitoring guidance",
        "Medication review & gradual de-prescribing",
        "Progress tracking with regular check-ins",
      ]}
    />
  );
}
